import React, { FC, ReactNode } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
}

const PageSidebar: FC<IProps> = ({ children }) => {
  return <div className={css.page__sidebar}>{children}</div>;
};

export default PageSidebar;
